import { RouteConfig } from 'vue-router';

import store from '@/store/store';
import { baseFilters } from '@/utils/baseFilters';
import Settings from '@/views/settings/List.vue';

export const settingListRoute: RouteConfig = {
  path: 'settings',
  name: 'settings',
  component: Settings,
  beforeEnter: (to, from, next) => {
    Promise.all([
      store.dispatch('settingGroups/list'),
      store.dispatch(`settings/list`, { ...baseFilters(to), noGroup: true })
    ])
      .then(() => {
        store.commit('breadcrumbs/set', [{ text: 'Ustawienia', disabled: true }]);
        next();
      })
      .catch(() => store.dispatch('notifyError', { title: 'Nie udało się pobrać ustawień' }));
  },
  meta: { toolbarTitle: 'Ustawienia' }
};

export const settingGroupRoute: RouteConfig = {
  path: 'settings/:id',
  name: 'settingsById',
  component: Settings,
  beforeEnter: (to, from, next) => {
    Promise.all([
      store.dispatch('settingGroups/list'),
      store.dispatch(`settings/list`, { ...baseFilters(to), groupId: parseInt(to.params.id) })
    ])
      .then(() => {
        store.commit('breadcrumbs/set', [{ text: 'Ustawienia', disabled: true }]);
        next();
      })
      .catch(() => store.dispatch('notifyError', { title: 'Nie udało się pobrać ustawień' }));
  },
  meta: { toolbarTitle: 'Ustawienia' }
};
